import { apiClient } from '../../utils';
import { handleError } from '../';

const removeCampaign = async ({ bid, site }) => {
  try {
    const data = { site, campaign: bid };
    const res = await apiClient.post('/merchant/campaign/remove', { data });

    return res.result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};

const removeCampaigns = async (bids, site) =>
  (bids || []).reduce(
    (acc, _, ci) =>
      acc.then(
        (_) =>
          new Promise((resolve, reject) => {
            if (!bids[ci]) return resolve();
            removeCampaign({ bid: bids[ci], site }).then(resolve).catch(reject);
          })
      ),
    Promise.resolve()
  );

export { removeCampaign, removeCampaigns };
